<template>
  <div class="pb20" id="rootchart" :style="cssVars">
    <div class="main CTABLE">
      <div class="title">REITs 日历</div>

      <div class="content_choose_area">
        <div class="chart7ChooseArea">
          <span>日期筛选</span>
          <CDatePicker
            :date.sync="detail_start_time"
            @fnGetBlockTradingDetail="fnGetCDatePicker"></CDatePicker>
          <span style="margin-left: 3vh; margin-right: 1vh">To</span>
          <CDatePicker
            :date.sync="detail_end_time"
            @fnGetBlockTradingDetail="fnGetCDatePicker"></CDatePicker>
          <CCascader
            v-if="date_type_list.length"
            style="margin-left: 30px"
            ref="date_type"
            :options="date_type_list"
            :default="date_type"
            @CCascader_select_val="fnCCascader_date_type"
            :checkStrictly="false"
            :multiple="true"
            :isDelete="false"
            :middle="true"
            :collapsetags="true"
            >事件筛选
          </CCascader>
        </div>
        <div class="downloadBtns">
          <CButtonsDownload
            :dButtonsDownloads="dButtonsDownloads1"
            @fnButtondownload="fnButtonDL" />

          <span style="display: none">
            <download-excel
              id="downloadExcel2"
              :data="dMvSnapshotTable"
              :fields="json_fields"
              header="REITs日历"
              name="REITs日历.xls">
            </download-excel>
          </span>
        </div>
      </div>
      <div v-if="calendarLoading" role="status" style="padding: 12px 0">
        正在加载所选日期；下方如有内容，仍为上一次成功加载的结果。
      </div>
      <div v-if="calendarError" role="alert" style="padding: 12px; color: inherit; border: 1px solid #f4b4ae; margin-bottom: 8px">{{ calendarError }}</div>
      <el-button v-if="calendarError" size="small" @click="retryCalendar">重新加载</el-button>
      <div v-if="!calendarLoading && !calendarError && calender_data.length && !dMvSnapshotTableTotal" role="status" style="padding: 12px 0">
        所选日期和事件类型暂无已公布事件。
      </div>
      <div class="table_area" ref="content_table">
        <el-row>
          <el-col :span="3" v-for="(item, index) in calender_data" :key="index">
            <table border="1" width="100%" align="right" :class="item.is_sse ? '' : 'sse_date'">
              <tr>
                <td align="right">{{ item.year + '年' + item.month + '月' + item.day + '日' }}</td>
              </tr>
              <tr>
                <td align="right">{{ '周' + item.week }}</td>
              </tr>
              <tr>
                <td align="right">
                  <div class="one_case">
                    <div
                      class="one"
                      :class="color_map[item2.date_type_L1]"
                      v-for="(item2, index2) in item.list"
                      :key="'one_' + index2">
                      <div class="one_left">
                        <span>{{ item2.date_type_L1 }}</span>
                      </div>
                      <div class="one_right">
                        <div class="one_d">
                          <div class="name">{{ item2.name }}{{ item2.reit_code?'('+item2.reit_code+')':'' }}</div>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="item2.text"
                            placement="bottom">
                            <div class="tag" @click="linkTo(item2.reit_code,item2.file_url)">
                              {{ item2.date_type_L2 }}
                            </div>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </el-col>
        </el-row>
      </div>
      <div class="button_case">
        <!-- 这里写左右切换按钮 -->
        <el-button
          @click="pre"
          type="primary"
          icon="el-icon-back"
          circle
          v-if="calender_data.length"></el-button>
        <el-button
          @click="next"
          type="primary"
          icon="el-icon-right"
          circle
          v-if="calender_data.length"></el-button>
      </div>
      <div class="sub_title" v-if="calender_data.length">主要日历事件</div>
      <div class="table_2" ref="content_table2" v-if="calender_data.length">
        <el-table
          class="table1"
          :header-cell-style="styleBindFun"
          :data="dMvSnapshotTableOne"
          style="width: 100%"
          header-row-class-name="valutionanalysis_yield_ttm">
          <el-table-column align="center" :width="96" prop="date_type_L1" label="事件大类">
            <template slot-scope="scope">
              <div :class="color_map[scope.row.date_type_L1]">
                <span class="span">{{ scope.row.date_type_L1 }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" :width="96" prop="date_type_L2" label="事件细分">
            <template slot-scope="scope">
              <div :class="color_map[scope.row.date_type_L1]">
                <span class="tag">{{ scope.row.date_type_L2 }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" :width="100" prop="reit_code" label="代码">
          </el-table-column>
          <el-table-column align="center" :width="250" prop="name" label="简称"> </el-table-column>
          <el-table-column align="center" :width="150" prop="show_date" label="事件日期">
            <template slot-scope="scope">
              <span class="tag">{{ scope.row.show_date}}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" prop="text" label="事件细项"> </el-table-column>

          <el-table-column align="center" :width="150" prop="file_url" label="对应公告">
            <template slot-scope="scope">
              <i class="el-icon-folder" @click="linkTo(scope.row.reit_code,scope.row.file_url)"></i>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            @current-change="handledPreipoList"
            :page-size="8"
            layout="total,  prev, pager, next, jumper"
            :total="dMvSnapshotTableTotal">
          </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import CDatePicker from '@/components/Basic/CDatePicker';
import CCascader from '@/components/Basic/CCascader2';
import CButtonsDownload from '@/components/Basic/CButtons_download';

import html2canvas from 'html2canvas';

import { fnReturnTableStyle, fnDownloadBgc } from '@/utils/util';

export default {
  components: {
    CDatePicker,
    CCascader,
    CButtonsDownload,
  },
  data() {
    return {
      ROOTFONTFIZE: 0,
      category_cascader_options: JSON.parse(localStorage.getItem('FINALLYCATEGORY')),

      color_map: { 项目动态: 'color_1', 分红: 'color_2', 解禁: 'color_3', 发行: 'color_4' },
      calender_data: [],
      calendarLoading: false,
      calendarError: '',
      calendarRequestId: 0,
      lastCalendarRequest: null,
      sse_list: [],
      table_list: [],
      max_length:0,

      json_fields: {
        日期: 'show_date',
        事件大类: 'date_type_L1',
        事件细分: 'date_type_L2',
        代码: 'reit_code',
        简称: 'name',
        事件细项: 'text',
        对应公告: 'file_url',
      },
      L1_L2_map: {},
      date_type_L1: [],
      date_type_L2: [],
      date_type_list: [],
      detail_start_time: '',
      detail_end_time: '',
      dMvSnapshotTableOne: [],
      dMvSnapshotTable: [],
      dMvSnapshotTableTotal:0,
      dButtonsDownloads1: [
        {
          id: '241009',
          name: '下载图片',
        },
        {
          id: '241009',
          name: '下载表格',
        },
      ],
      sCurrentTheme: this.$store.state.theme == 'dark' ? true : false,
    };
  },
  mounted() {
    window.addEventListener('resize', this.funResize);
    this.fnGetWidth();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.funResize);
  },
  methods: {
    funResize() {
      this.fnGetWidth();
    },
    styleBindFun() {
      let val = this.$store.state.theme == 'dark' ? true : false;
      return fnReturnTableStyle(val);
    },
    fnGetTheme() {
      this.sCurrentTheme = this.$store.state.theme == 'dark' ? true : false;
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
    },
    fnButtonDL(val) {
      if (val == '下载图片') {
        this.FnDownload();
      } else {
        document.getElementById('downloadExcel2').click();
      }
    },
    FnDownload() {
      let h = this.$refs.content_table.scrollHeight;
      let w = this.$refs.content_table.scrollWidth;
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      html2canvas(this.$refs.content_table, {
        height: h + 20,
        width: w,
        backgroundColor: fnDownloadBgc(this.sCurrentTheme),
        useCORS: true,
        scale: 1,
      }).then((canvas) => {
        let url = canvas.toDataURL('image/png');
        var a = document.createElement('a'); // 生成一个a元素
        var event = new MouseEvent('click'); // 创建一个单击事件
        a.download = 'REITs日历'; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      });

      let h2 = this.$refs.content_table2.scrollHeight;
      let w2 = this.$refs.content_table2.scrollWidth;
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      html2canvas(this.$refs.content_table2, {
        height: h2 + 20,
        width: w2,
        backgroundColor: fnDownloadBgc(this.sCurrentTheme),
        useCORS: true,
        scale: 1,
      }).then((canvas) => {
        let url = canvas.toDataURL('image/png');
        var a = document.createElement('a'); // 生成一个a元素
        var event = new MouseEvent('click'); // 创建一个单击事件
        a.download = 'REITs日历'; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      });
    },
    renderHeader(h, { column }) {
      var str = '';
      if (column.label == '计量总量') {
        str = '建筑面积（sqm）/污水处理量(吨/日)/总装机容量(MW)/公路长度（km）';
      }
      return h('span', [
        h('span', column.label),
        h(
          'el-tooltip',
          {
            props: {
              effect: 'dark',
              content: str,
              placement: 'top',
            },
          },
          [
            h('i', {
              class: 'el-icon-question',
              style: 'color:#409eff;margin-left:5px;',
            }),
          ]
        ),
      ]);
    },
    handleClick(e) {
      if (e.name == 'first') {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        this.detail_start_time = `${year}-${month}-01`;
        currentDate.setMonth(currentDate.getMonth() + 1); // 跳到下个月
        currentDate.setDate(0); // 设置为上个月的最后一天
        this.detail_end_time = `${year}-${month}-${currentDate.getDate()}`;
        this.fnGetDateType(()=>{
          this.fnGetCDatePicker();
        });
      }
    },

    fnCCascader_date_type(val) {
      this.date_type_L1 = [];
      this.date_type_L2 = [];
      val.forEach((item) => {
        console.log("date_type_L2",item);
        if (this.L1_L2_map[item] == 'L1') {
          this.date_type_L1.push(item);
        } else {
          this.date_type_L2.push(item);
        }
      });
      this.fnGetCDatePicker();
    },

    async fnGetDateType(fun) {
      const { data } = await this.$https.get('/api/v2_5/reit_calendar_button');

      if (data.code !== 200) return this.$message.error(data.msg);
      let date_type_list = [];
      this.date_type_L1 = [];
      this.date_type_L2 = [];
      let L1_L2_map = {};
      for (var key in data.data) {
        var list = data.data[key];
        var one = {
          label: key,
          value: key,
          children: [],
        };
        this.date_type_L1.push(key);
        L1_L2_map[key] = 'L1';
        list.forEach((item) => {
          one.children.push({
            label: item,
            value: item,
          });
          L1_L2_map[item] = 'L2';
          this.date_type_L2.push(item);
        });
        date_type_list.push(one);
      }
      this.L1_L2_map = L1_L2_map;
      this.date_type_list = date_type_list;
      fun&&fun();
    },
    fnGetCDatePicker() {
      if (!this.detail_start_time || !this.detail_end_time) {
        return;
      }
      let detail_start_time = this.getStartTime(this.detail_start_time);
      let detail_end_time = this.getEndTime(this.detail_end_time);
      const [year, month] = this.detail_start_time.split('-');
      this.year = year;
      this.month = month;
      this.is_filter = true;
      return this.fnReitCalendarSseDate(detail_start_time, detail_end_time, this.year, this.month);
    },
    retryCalendar() {
      const request = this.lastCalendarRequest;
      if (request) {
        return this.fnReitCalendarSseDate(...request);
      }
      return this.fnGetCDatePicker();
    },
    async fnReitCalendarSseDate(start, end, year, month) {
      const requestId = ++this.calendarRequestId;
      this.lastCalendarRequest = [start, end, year, month];
      this.calendarLoading = true;
      this.calendarError = '';
      const params = new URLSearchParams({ start_date: start, end_date: end });
      // Keep the existing API contract, including empty filter selections.
      (this.date_type_L1.length ? this.date_type_L1 : ['']).forEach(value => params.append('date_type_L1', value));
      (this.date_type_L2.length ? this.date_type_L2 : ['']).forEach(value => params.append('date_type_L2', value));
      try {
        const [marketResponse, eventResponse] = await Promise.all([
          this.$https.get(`/api/v2_5/reit_calendar_sse_date?start_date=${encodeURIComponent(start)}&end_date=${encodeURIComponent(end)}`),
          this.$https.get(`/api/v2_5/reit_calendar?${params.toString()}`),
        ]);
        if (requestId !== this.calendarRequestId) return;
        for (const response of [marketResponse, eventResponse]) {
          if (!response.data || response.data.code !== 200 || !Array.isArray(response.data.data)) {
            throw new Error((response.data && response.data.msg) || '日历数据返回异常');
          }
        }
        this.applyCalendarData(eventResponse.data.data, marketResponse.data.data, year, month);
      } catch (error) {
        if (requestId !== this.calendarRequestId) return;
        this.calendarError = this.calender_data.length
          ? '所选日期加载失败，下方保留上一次成功加载的结果。请点击重新加载。'
          : '日历加载失败，请点击重新加载。';
      } finally {
        if (requestId === this.calendarRequestId) this.calendarLoading = false;
      }
    },
    applyCalendarData(events, tradingDates, year, month) {
      const tradingSet = new Set(tradingDates);
      const eventsByDate = {};
      events.forEach(event => {
        if (!eventsByDate[event.show_date]) eventsByDate[event.show_date] = [];
        eventsByDate[event.show_date].push(event);
      });
      const days = this.generateCalendar(year, month);
      const table = [];
      let maxLength = 0;
      days.forEach(day => {
        day.is_sse = tradingSet.has(day.data);
        day.list = eventsByDate[day.data] || [];
        maxLength = Math.max(maxLength, day.list.length);
        table.push(...day.list);
      });
      table.reverse();
      this.sse_list = tradingDates;
      this.calender_data = days;
      this.max_length = maxLength;
      this.dMvSnapshotTable = table;
      this.dMvSnapshotTableTotal = table.length;
      this.dMvSnapshotTableOne = table.slice(0, 8);
    },

    pre() {
      this.is_filter = false;
      let year = parseInt(this.year);
      let month = parseInt(this.month);
      month--;
      if (month < 1) {
        month = 12;
        year--;
      }
      this.year = year;
      this.month = month;
      let detail_start_time = this.getStartTime(
        this.year + '-' + (this.month < 10 ? '0' + this.month : this.month) + '-01'
      );
      let detail_end_time = this.getEndTime(this.detail_end_time);
      return this.fnReitCalendarSseDate(detail_start_time, detail_end_time, this.year, this.month);
    },
    next() {
      this.is_filter = false;
      let year = parseInt(this.year);
      let month = parseInt(this.month);
      month++;
      if (month > 12) {
        month = 1;
        year++;
      }
      this.year = year;
      this.month = month;
      let detail_start_time = this.getStartTime(
        this.year + '-' + (this.month < 10 ? '0' + this.month : this.month) + '-01'
      );
      var detail_end_time = this.getEndTime(this.year + '-' + (this.month < 10 ? '0' + this.month : this.month) + '-01');
      // let detail_end_time = this.getEndTime(this.detail_end_time);
      return this.fnReitCalendarSseDate(detail_start_time, detail_end_time, this.year, this.month);
    },

    linkTo(reit_code,url) {
      if (url && url != 'nan') {
        if(url.indexOf('conghua-obs.obs.cn-north-4.myhuaweicloud.com') != -1){
          window.open('https://database.chopinsight.cn/api/common/query/download/get?proxy_url='+url);
          return; 
        }
        window.open(url);
      }
    },
    //日历表
    generateCalendar(year, month) {
      const firstDay = new Date(year, month - 1, 1);
      const lastDay = new Date(year, month, 0);
      const startWeekday = firstDay.getDay();
      const totalDays = lastDay.getDate();

      // 生成前月补位（含完整日期信息）
      const preDays = Array.from({ length: startWeekday }, (_, i) => {
        const date = new Date(year, month - 1, -startWeekday + i + 1);
        return {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate(),
          data:
            date.getFullYear() +
            '-' +
            (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) +
            '-' +
            (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()),
          week: ['日', '一', '二', '三', '四', '五', '六'][date.getDay()],
          isCurrentMonth: false,
        };
      });

      // 生成当月日期
      const currentDays = Array.from({ length: totalDays }, (_, i) => {
        const date = new Date(year, month - 1, i + 1);
        return {
          year,
          month,
          day: i + 1,
          data:
            year +
            '-' +
            (parseInt(month) < 10 ? '0' + parseInt(month) : parseInt(month)) +
            '-' +
            (i + 1 < 10 ? '0' + (i + 1) : i + 1),
          week: ['日', '一', '二', '三', '四', '五', '六'][date.getDay()],
          isCurrentMonth: true,
        };
      });

      // 计算后月补位
      const postDays = Array.from(
        {
          length: (7 - ((preDays.length + totalDays) % 7)) % 7,
        },
        (_, i) => {
          const date = new Date(year, month, i + 1);
          return {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
            data:
              date.getFullYear() +
              '-' +
              (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) +
              '-' +
              (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()),
            week: ['日', '一', '二', '三', '四', '五', '六'][date.getDay()],
            isCurrentMonth: false,
          };
        }
      );

      const calendar = [...preDays, ...currentDays, ...postDays];
      return calendar;
    },
    getStartTime(detail_start_time) {
      const [year, month, day] = detail_start_time.split('-');
      var first_day = this.generateCalendar(year, month)[0];
      return first_day['data'];
    },
    getEndTime(detail_end_time) {
      const [year, month, day] = detail_end_time.split('-');
      var list = this.generateCalendar(year, month);
      var last_day = list[list.length - 1];
      return last_day['data'];
    },
    handledPreipoList(val) {
      let start = (val - 1) * 8;
      let end = start + 8;
      // 分页 start
      this.dMvSnapshotTableOne = this.dMvSnapshotTable.filter((node, idx) => {
        return idx >= start && idx < end;
      });
    },
  },
  computed: {
    date_type() {
      var value = [];
      this.date_type_list.forEach((item) => {
        item.children.forEach((item2) => {
          value.push([item.value, item2.value]);
        });
      });
      return value;
    },
    cssVars() {
      return {
        '--ROOTFONTFIZE': this.ROOTFONTFIZE + 'px',
      };
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
  },
  created() {},
  watch: {
    currentTheme(newVal, oldVal) {
      this.styleBindFun();
      this.fnGetTheme();
      fnDownloadBgc();
    },
  },
};
</script>

<style lang="less" scoped>
.pb20 {
  padding-bottom: 20px;
}

.main {
  background-color: var(--charts_bgc);
  padding-top: 15px;
  border-radius: 20px;
  height: 654px;
  height: auto;
  padding-bottom: 20px;
}

.CTABLE {
  height: auto;
}

// 切换按钮  start --------------------------------------------
.chooseArea {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chooseArea .el-button {
  font-size: 14px;
  font-weight: 400;
  height: 36px;
  // margin-left: 10px;
}

.chooseArea .noActive {
  // background-color: var(--Select-bgc);
  // background-color: red;
  // color: var(--Select-color2);
  // border: 0.98px solid rgba(255, 255, 255, 0.2);

  background-color: var(--Btn-bgc2);
  color: var(--stock_area_item_color1);
  border: 1px solid var(--Btn-borderColor);
}

.checkedBtnStyle {
  // background-color: #1573fe !important;
  background-color: var(--primary-color) !important;
  // color: #ffffff !important;
  color: var(--Btn-color) !important;
  // border: 0.98px solid #1573fe !important;
  border: 1px solid var(--primary-color) !important;
}

.chooseArea .el-button:hover {
  background-color: var(--Btn-bgc_hover);
  color: var(--Btn-color2);
  border: 1px solid var(--primary-color) !important;
}
.chart7ChooseArea {
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  display: flex;
  align-items: center;
  color: var(--RelatedInstitutions_item_color2);
}

// 切换按钮  end --------------------------------------------

.title {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 28px;
  color: var(--chart_title);
  // border-left: 5px solid rgba(21, 115, 254, 1);
  border-left: 5px solid var(--primary-color);
  padding-left: 13px;
  padding-right: 38px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-top: 15px;
}

.main_choose {
  padding-left: 18px;
  margin-top: 25px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  position: relative;
}

.main_choose_center {
  display: flex;
  justify-content: center;
}

.main_choose span {
  margin-right: 50px;
  display: flex;
  align-items: center;
  color: var(--chart_title);
  font-size: 14px;
}

.btnArea {
  margin-right: 40px;
}

.colorCategory {
  margin-left: 39px;
}

.summary {
  margin-left: 120px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.25px;
  line-height: 20px;
  color: rgba(255, 255, 255, 1);
  width: 52px;
  display: flex;
  justify-content: space-between;
}

.average {
  margin-left: 120px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.25px;
  line-height: 20px;
  color: rgba(255, 255, 255, 1);
  width: 92px;
  display: flex;
  justify-content: space-between;
}

// .width20{
//   width: 27%;
// }

// .mobility span:nth-child(1){
//   margin-left: 0px ;
// }

.category {
  margin-left: 50px;
}

.content_choose_area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 28px;
  margin-top: 20px;
}

.summary_style {
  color: var(--cascader-color);
  font-size: 14px;
  margin-left: 50px;
}

.content_choose_area_item {
  flex: 1;
  position: relative;
  padding-top: 20px;
}

.content_choose_area_item:nth-child(1) {
  margin-right: 20px;
}

.color_pier {
  position: absolute;
  top: 10%;
  right: 2%;
}

.color_pier_tit {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.51px;
  line-height: 20.58px;
  color: rgba(158, 158, 158, 1);
}

.color_pier_main {
  width: 24px;
  height: 350px;
  float: right;
  margin-top: 20px;
  // margin: 20px auto;
  background: linear-gradient(
    to top,
    #f5fbfc,
    #e9f7fa,
    #c4e9e2,
    #99d8c9,
    #7bcbb3,
    #51b78a,
    #248c46,
    #006328
  );
  border-radius: 5px;
}

.roseCard {
  // padding-bottom: 30px !important;
}

.content_area {
  padding: 20px 20px 0px;
}

.CLASSB_STYLE {
  margin-left: 17px;
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: #1d1f25;
  background-color: var(--table_bgc);
  padding-bottom: 70px !important;
}

::v-deep .el-table::before {
  // background-color: #1d1f25;
  background-color: var(--table_bgc);
}

::v-deep .table1 table {
  border: none;
}

::v-deep .el-table__body-wrapper {
  height: auto !important;
  max-height: 100% !important;
  // padding-bottom: 10px !important;
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  border-bottom: 1px solid var(--table_brc);
  height: 60px;
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  color: var(--table_color_hover);
  cursor: pointer;
}

// el-table end

.content {
  margin: 0 20px;
  background-color: var(--charts_bgc);
  border: 1px solid var(--charts_brc);
  border-radius: 10px;
  position: relative;
  // margin-top: 30px;
}

.icon-fangda {
  // right: 6% !important;
}

.icon-fangd3 {
  right: 90px !important;
}

// echarts

.info {
  margin-left: 26px;
  margin-bottom: 14px;
}

.DDL_info {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.51px;
  line-height: 20.58px;
  color: rgba(158, 158, 158, 1);
  padding-bottom: 15px;
  padding-left: 10px;
}

.value_area {
  display: flex;
  align-items: center;
  justify-content: start;
}

.a {
  height: 20px;
  border-radius: 3px;
  margin-right: 10px;
  background-color: rgba(90, 232, 237, 1);
}

.b {
  height: 20px;
  border-radius: 3px;
  margin-right: 10px;
  background-color: rgba(90, 232, 237, 1);
}

.c {
  height: 20px;
  border-radius: 3px;
  margin-right: 10px;
  background-color: rgba(59, 79, 207, 1);
}

.d {
  height: 20px;
  border-radius: 3px;
  margin-right: 10px;
  background-color: rgba(255, 51, 0, 1);
}

// 数据截止日期
.deadline {
  padding-left: 20px;
  padding-bottom: 20px;
}

.deadline2 {
  position: absolute;
  bottom: 0;
  color: #f8b077;

  // left: 20px;
}

.plotly .legend {
  margin-top: -20px; /* 调整图例距离顶部的距离 */
}

// 日历的样式
.table_area {
  padding: 30px;
  box-sizing: border-box;
  td {
    padding: 10px;
    box-sizing: border-box;
    font-size: 12px !important;
    color: var(--chart_title);
  }
  tr:nth-child(1),
  tr:nth-child(2) {
    background-color: var(--calender_background_color);
    height: 30px;
  }
  .el-col-3 {
    width: 100%/7;
  }
  .sse_date {
    tr:nth-child(1),
    tr:nth-child(2) {
      background-color: var(--calender_sse_date_background_color) !important;
    }
  }
  
/* 确保 el-row 作为 Flex 容器且允许拉伸 */
.el-row {  
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
}

/* 强制 el-col 高度继承父容器 */
.el-col {
  display: flex;          /* 将 el-col 转为 Flex 容器 */
  flex-direction: column; /* 垂直排列内部元素 */
}

/* 内部内容容器撑满高度 */
.el-col > * {
  flex: 1; /* 关键：让内部元素占满剩余高度 */
  width: 100%;
}
  .one_case {
    min-height: 150px;
    // overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
      background-color: var(--calender_sse_date_background_color);
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--calender_background_color);
    }
  }
  .one {
    width: 100%;
    display: flex;
    .one_left {
      // width: 35%;
      span {
        padding: 3px;
        border-radius: 4px;
        color: white;
      }
    }
    .one_right {
      flex: 1;
      margin-left: 5%;
      // width: 60%;
      .one_d {
        width: 100%;
        .name {
          text-align: left;
        }
        .tag {
          text-align: left;
        }
      }
    }
  }

  .color_1 {
    span {
      background-color: #b75ead;
    }
    .tag {
      color: #b75ead;
    }
  }
  .color_2 {
    span {
      background-color: #e97132;
    }
    .tag {
      color: #e97132;
    }
  }
  .color_3 {
    span {
      background-color: #388db4;
    }
    .tag {
      color: #388db4;
    }
  }
  .color_4 {
    span {
      background-color: #2f7d6d;
    }
    .tag {
      color: #2f7d6d;
    }
  }
}
.button_case {
  padding: 0 30px;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: end;
  ::v-deep .el-button--primary {
    color: var(--cascader-bgc2) !important;
    background-color: var(--primary-color) !important;
    border-color: var(--primary-color) !important;
  }
}
.sub_title {
  padding: 0 30px;
  box-sizing: border-box;
  width: 100%;
  font-size: calc(var(--ROOTFONTFIZE) * (20 / 144));
  font-weight: 580;
  color: var(--chart_title);
}
.table_2 {
  padding: 30px;
  box-sizing: border-box;
  .color_1 {
    .span {
      padding: 5px;
      background-color: #b75ead;
      color: white;
    }
    .tag {
      color: #b75ead;
    }
  }
  .color_2 {
    .span {
      padding: 5px;
      background-color: #e97132;
      color: white;
    }
    .tag {
      color: #e97132;
    }
  }
  .color_3 {
    .span {
      padding: 5px;
      background-color: #388db4;
      color: white;
    }
    .tag {
      color: #388db4;
    }
  }
  .color_4 {
    .span {
      padding: 5px;
      background-color: #2f7d6d;
      color: white;
    }
    .tag {
      color: #2f7d6d;
    }
  }
}
/* // 分页 - start */

.el-pagination {
  text-align: center;
  margin-top: calc(var(--ROOTFONTFIZE) * (20 / 144));
  margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
}

::v-deep .el-pagination__total,
::v-deep .el-pagination__jump {
  color: var(--pagination_editor_color) !important;
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144)) !important;
}

::v-deep .el-pagination .btn-prev,
::v-deep .el-pagination .btn-next {
  background-color: transparent;
  color: var(--pagination_prev_color) !important;
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144)) !important;
}

::v-deep .el-pager li {
  background-color: var(--pagination_li_bgc) !important;
  color: var(--pagination_li_color) !important;
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144)) !important;
}

::v-deep .el-pager li.active {
  background-color: var(--primary-color) !important;
  color: var(--pagination_li_active_color) !important;
}

::v-deep .el-pagination__editor.el-input .el-input__inner {
  background-color: var(--pagination_editor_bgc) !important;
  color: var(--pagination_editor_color);
  border: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--pagination_editor_brc);
}

::v-deep .el-timeline-item__timestamp {
  position: absolute;
  left: calc(var(--ROOTFONTFIZE) * (-150 / 144));
  top: 0;
  color: var(--pagination_timestamp_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
}
/* // 分页 - end */
</style>
